export const TOKEN_KEY = "token";
export const ADMIN_KEY = "admin";
export const ORDER_KEY = "order";
export const ORDER_ITEM_KEY = "order_items"; 